// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2oHB2","sendOtp":"AuthorizeToLogin_sendOtp__1OGLU"};